/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { NormalUser } from './NormalUser';
import { Tenant } from './Tenant';
const OTPLoginableUserParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['tenant', /* #__PURE__ */ parsers.maybeNull(Tenant)],
    ['canLogin', codecBoolean, 'can_login'],
]), NormalUser);
export class OTPLoginableUser extends NormalUser {
    static decode(input) {
        return OTPLoginableUserParser.decode(input).map(res => new OTPLoginableUser(res));
    }
    static unsafeDecode(input) {
        return OTPLoginableUser.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return OTPLoginableUserParser.encode(data);
    }
    static schema() {
        return OTPLoginableUserParser.schema();
    }
}
